import axios from "axios";
import Config from "@/config"

export default class AiService {
  botStart(accesstoken, stream) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("ai") + "/bot/start" + (stream ? "?stream=true" : ""), null,
        options
      )
      .then(res => res.data);
  }
  botSendMessage(accesstoken, text, stream, resetSession) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("ai") + "/bot/message" + (stream ? "?stream=true" : ""), {
          message: text,
          "reset_session_id": resetSession ? true : false
        },
        options
      )
      .then(res => res.data);
  }
  botDeleteChatSessionHistory(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .delete(
        Config.proxy + Config.url("ai") + "/bot/message/history", 
        options
      )
      .then(res => res.data);
  }
}
